import AICampusFooter from '@/components/probaworkflows_base_components/AICampusFooter/AiFooter.vue';
import ApplicationFilter from "@/components/probaworkflows_base_components/ApplicationFilter/ApplicationFilter.vue";
import GlobalTable from "@/components/probaworkflows_base_components/GlobalTable/GlobalTable.vue";
import ReportLaunchPanel from "@/components/probaworkflows_base_components/ReportLaunchPanel/ReportLaunchPanel.vue";
import {
  CREATE_ENTITY_APPLICATION_ONLY,
  DELETE_APPLICATION_URL,
  ENTITY_REGISTER,
  GET_ENTITY_TYPE_FORMS,
  get_headers,
  get_project_id,
  get_token,
  LIST_ASSIGNED_CHILD_ENTITY_TYPES_URL,
  LIST_SUB_ENTITIES_BY_PARENT_APPLICATION,
  MOVE_ENTITY_URL,
  VIEW_ENTITY_TYPE_URL,
  VIEW_PENDING_APPLICATIONS_URL,
} from "@/utils/constants/constants.js";
import alert_mixin from "@/utils/mixins/alert_mixin";
import formatting_mixins from "@/utils/mixins/formatting_mixins";
import { validate_email, validate_non_sub_zero_number, validate_phone_number } from "@/utils/validations/validate_inputs";
import axios from "axios";
import "datatables.net";
import "datatables.net-dt/css/dataTables.dataTables.css";
import $ from 'jquery';

export default {
  name: "PendingApplications",
  mixins: [alert_mixin, formatting_mixins],
  components: {
    GlobalTable,
    AICampusFooter,
    ApplicationFilter,
    ReportLaunchPanel,
  },
  data: () => ({
    token: "",
    project_id: "",
    selected_status: "",
    display_name: "",
    entity_type_id: "",
    headers: {},
    pending_applications_list: [],
    table_headers: [],
    sanitized_pending_applications_list: [],
    displayed_applications_list: [],
    total_entities: 0,
    user_ids: [],
    profile_role_ids: [],
    application_row_map: {},
    show_assign_modal: false,
    current_form: {
      parent_id: null,
      parent_name: '',
      child_id: '',
      parent_application_id: '',
      parent_entity_profile_id: '',
    },
    available_children: [],
    displayed_assigned_children: [],
    entity_type: [],
    form_list: [],
    selected_form_id: "",
    first_name: '',
    last_name: '',
    phone_number: '',
    email: '',
    assign_sub_entity_type_id: '',
    assign_sub_entity_options: [],
    assign_form_list: [],
    assign_selected_form_id: '',
    assign_first_name: '',
    assign_last_name: '',
    assign_email: '',
    assign_phone_number: '',
    filters: {
      search: "",
      entity_type_id: "",
      date_from: "",
      date_to: "",
    },
    show_filters: false,
    assign_entity_name: "",
    lock_entity_type: false,
    // Track all available statuses from backend
    available_statuses: [],
    include_email: false,
    show_move_modal: false,
    should_mount_report_builder: false,
    move_form: {
      entity_profile_id: null,
      new_entity_type_id: "",
      form_ids: [],
      selected_form_id: "",
    },
    move_entity_type_options: [], // reuse this.entity_type if you want
    move_form_list: [],
  }),
  created() {
    this.token = get_token();
    this.project_id = get_project_id();
    this.headers = get_headers();

    if (!validate_non_sub_zero_number(parseInt(this.project_id, 10))) {
      this.show_error("Project ID must not be null or zero");
    }
  },

  mounted() {
    this.filter_by = sessionStorage.getItem("filter_by")
      ? JSON.parse(sessionStorage.getItem("filter_by"))
      : [];

    this.on_route_change();
    this.get_parent_entity_type();
    this.view_created_entity_type();
  },
  watch: {
    "$route.query": {
      deep: true,
      handler() {
        this.on_route_change();
      }
    },

    entity_type_id(newVal) {
      if (newVal) this.get_forms();
    },

    show_assign_modal(val) {
      if (typeof document !== 'undefined') {
        document.body.classList.toggle('v-modal-open', !!val);
      }
    }
  },
  methods: {
    on_route_change() {
      this.apply_status_from_route();
      this.apply_entity_type_from_route();
      this.apply_display_name_from_route();

      this.lock_entity_type = !!this.entity_type_id;

      if (this.entity_type_id && (!this.form_list.length || !this.selected_form_id)) {
        this.get_forms();
      }

      this.view_pending_applications();
    },

    apply_status_from_route() {
      const raw = (this.$route.query.status || "")
        .toString()
        .trim()
        .toLowerCase();
      this.selected_status = raw;
    },

    apply_display_name_from_route() {
      const cached_display_name = sessionStorage.getItem('display_name') || '';
      if (cached_display_name) {
        this.display_name = cached_display_name;
        return;
      }

      this.display_name = '';
    },

    apply_entity_type_from_route() {
      const raw = (this.$route.query.entity_type_id ?? '').toString().trim();
      this.entity_type_id = /^\d+$/.test(raw) ? Number(raw) : '';
      this.filters = { ...this.filters, entity_type_id: this.entity_type_id || '' };
    },

    async view_pending_applications() {
      return this.show_loader("Loading pending applications...")
        .then(loader => {
          this.displayed_applications_list = [];
          this.table_headers = [];
          const project_id = parseInt(this.project_id, 10);
          if (!validate_non_sub_zero_number(project_id)) {
            this.show_error("Project ID must not be null or zero");
            return this.close_loader(loader);
          }

          const params = {
            project_id: project_id,
            entity_type_name: this.entity_type_name,
            ...(this.entity_type_id ? { entity_type_id: this.entity_type_id } : {}),
            status_id: this.$route?.query?.status_id || this.get_filter_value(),
          };

          const api_url = this.get_api_url();

          return axios.get(api_url, {
            headers: this.headers,
            params: params,
          })
            .then(response => {
              const response_data = response.data;

              if (response_data.status !== "success") {
                this.show_error("Error occurred while pulling pending applications");
                return this.close_loader(loader);
              }

              let pending_entities = [];
              this.application_user_map = {};

              try {
                pending_entities = response_data.data.list_pending_entities || [];
                this.pending_applications_list = pending_entities.map((entity) => {
                  const user_id = this.get_user_id_from_entity(entity);
                  this.application_user_map[entity.id] = user_id;
                  return {
                    ...entity,
                    user_id,
                  };
                });

                // Extract and update available statuses from backend
                this.extract_available_statuses(pending_entities);

                this.form_idsArray = this.pending_applications_list
                  .map((entity) => entity.form?.id)
                  .filter(Boolean);
              } catch (error) {
                this.pending_applications_list = [];
                this.application_user_map = {};
              }

              this.prep_tables();

              this.counts_initialized = true;
              return this.close_loader(loader);
            })
            .catch(error => {
              const errorMsg =
                error.response?.data?.message || "An unexpected error occurred";
              this.show_error(`Error retrieving applications: ${errorMsg}`);
              return this.close_loader(loader);
            });
        });
    },

    extract_available_statuses(entities) {
      const statusSet = new Set();
      entities.forEach(entity => {
        if (entity.status?.status) {
          statusSet.add(entity.status.status);
        }
      });
      this.available_statuses = Array.from(statusSet);
    },

    reset_move_modal() {
      this.show_move_modal = false;
      this.move_form = {
        entity_profile_id: null,
        new_entity_type_id: "",
        form_ids: [],
        selected_form_id: "",
      };
      this.move_form_list = [];
    },

    prepare_report_builder() {
      this.should_mount_report_builder = true;
    },


    open_move_modal(row) {
      const application_id = Number(Reflect.get(row || {}, "Application No") || 0);
      if (!application_id) {
        this.show_error("Unable to find Application No for this row.");
        return;
      }

      const original = this.pending_applications_list.find(a => Number(a.id) === application_id);
      if (!original) {
        this.show_error("Original application not found.");
        return;
      }

      const entity_profile_id = Number(original.entity || 0);
      if (!entity_profile_id) {
        this.show_error("Unable to find entity_profile_id (entity) on application.");
        return;
      }

      this.move_form.entity_profile_id = entity_profile_id;

      this.move_form.new_entity_type_id = "";
      this.move_form.form_ids = [];
      this.move_form.selected_form_id = "";
      this.move_form_list = [];

      $("#open_move_entity_modal_btn").trigger("click");
    },

    on_move_form_change() {
      const selected = Number(this.move_form.selected_form_id || 0);
      this.move_form.form_ids = selected ? [selected] : [];
    },



    async on_move_entity_type_change() {
      this.move_form_list = [];
      this.move_form.form_ids = [];
      this.move_form.selected_form_id = "";
      const entity_type_id = Number(this.move_form.new_entity_type_id || 0);
      if (!entity_type_id) return;

      try {
        const res = await axios.get(GET_ENTITY_TYPE_FORMS, {
          headers: this.headers,
          params: { entity_type_id },
        });

        // Your API sometimes returns JSON string
        const parsed = typeof res.data === "string" ? JSON.parse(res.data) : res.data;

        // common patterns: parsed.data OR parsed.data.data
        const forms = Array.isArray(parsed?.data)
          ? parsed.data
          : Array.isArray(parsed?.data?.data)
            ? parsed.data.data
            : [];

        this.move_form_list = forms;
      } catch (e) {
        const msg = e.response?.data?.message || e.message || "Failed to load forms.";
        this.show_error(msg);
      }
    },

    async submit_move_entity() {
      return this.show_loader("Moving entity...")
        .then(async (loader) => {
          const entity_profile_id = Number(this.move_form.entity_profile_id || 0);
          if (!entity_profile_id) {
            this.show_error("Missing entity_profile_id.");
            return this.close_loader(loader);
          }

          const new_entity_type_id = Number(this.move_form.new_entity_type_id || 0);
          if (!new_entity_type_id) {
            this.show_error("Please select a new entity type.");
            return this.close_loader(loader);
          }

          const form_ids = Array.isArray(this.move_form.form_ids)
            ? this.move_form.form_ids.map(id => Number(id)).filter(Boolean)
            : [];

          if (form_ids.length === 0) {
            this.show_error("Please select at least one form.");
            return this.close_loader(loader);
          }

          const payload = {
            entity_profile_id,
            new_entity_type_id,
            form_ids,
          };

          try {
            const res = await axios.post(MOVE_ENTITY_URL, payload, { headers: this.headers });

            const body = typeof res.data === "string" ? JSON.parse(res.data) : res.data;

            if (body?.status !== "success") {
              this.show_error(body?.message || "Failed to move entity.");
              return this.close_loader(loader);
            }

            this.show_success(body?.message || "Entity moved successfully.");

            // Close modal (works if you already have close_modal helper)
            // Otherwise bootstrap will close via data-bs-dismiss on cancel only.
            // We'll force close by clicking the close button if needed.
            this.reset_move_modal();
            $("#move_entity_modal .btn-close").trigger("click");

            // Refresh list
            await this.view_pending_applications();

            return this.close_loader(loader);
          } catch (e) {
            const msg = e.response?.data?.message || e.message || "Error moving entity.";
            this.show_error(msg);
            return this.close_loader(loader);
          }
        });
    },


    get_api_url() {
      return VIEW_PENDING_APPLICATIONS_URL;
    },

    get_filter_value() {
      if (this.selected_status) {
        const backend_filter = this.selected_status.replace(/-/g, "_");
        return backend_filter;
      }
      return this.filter_by.length > 0 ? this.filter_by.join(",") : undefined;
    },

      get_user_id_from_entity(entity) {
        const profile_user = entity.profile_role?.profile?.user;
        if (profile_user?.id) return profile_user.id;

        if (entity.profile_role?.profile?.user_id) {
          return entity.profile_role.profile.user_id;
        }
        if (entity.entity_type?.user_id) {
          return entity.entity_type.user_id;
        }

        return null;
      },

    prep_tables() {
      if (this.pending_applications_list.length > 0) {
        this.sanitized_pending_applications_list = [];
        this.application_row_map = new Map();

        const backend_filter = this._normalize_status_filter(this.selected_status);

        const has_master_registered = this._collection_has_master(this.pending_applications_list);

        this.table_headers = this._build_headers(has_master_registered);

        this.sanitized_pending_applications_list = this.pending_applications_list
          .filter(app => this.should_include_application(app, backend_filter))
          .map(app => {
            const formatted = this.format_application(app, has_master_registered);

            if (formatted && Reflect.get(formatted, "Application No")) {
              Reflect.set(
                this.application_row_map,
                String(Reflect.get(formatted, "Application No")),
                formatted
              );
            }

            return formatted;
          });

        this.displayed_applications_list = Array.from(this.sanitized_pending_applications_list || []);
      } else {
        const display_label = this._get_display_name_label();
        this.table_headers = [
          "Application No",
          `${display_label} Name`,
          `${display_label} Type`,
          "Date Created",
          "Status"
        ];
        this.displayed_applications_list = [];
      }
    },

    _normalize_status_filter(selected_status) {
      return selected_status
        ? selected_status.toLowerCase().replace(/-/g, "_")
        : null;
    },

    _collection_has_master(apps) {
      return apps.some(app => {
        const status = (app.status?.status || "").toLowerCase();
        return status.includes("master registered") || status.includes("master_registered");
      });
    },

    _build_headers(has_master_registered) {
      const display_label = this._get_display_name_label();
      return [
        "Case No",
        ` Name`,
        `${display_label} Type`,
        "Date Created",
        "Status",
        ...(has_master_registered ? ["Case Number"] : [])
      ];
    },

    _get_display_name_label() {
      return this.display_name || "Case";
    },

    get_table_headers(applications) {
      if (!applications || applications.length === 0) {
        return [];
      }

      const display_label = this._get_display_name_label();
      const base_headers = [
        "Case No",
        `Name`,
        `${display_label} Type`,
        "Date Created",
        "Status"
      ];

      const has_master_registered_with_trust = applications.some(app => {
        const id = String(Reflect.get(app || {}, "Case No"));
        const raw_app = Reflect.get(this.application_row_map, id);

        const raw_status =
          raw_app?.status?.status ||
          app.Status ||
          "";

        const is_master_registered = raw_status.toLowerCase().includes("master registered");
        const has_trust_number =
          raw_app?.trust_number ||
          Reflect.get(app || {}, "Trust Number");

        return is_master_registered && has_trust_number;
      });

      if (has_master_registered_with_trust) {
        return [...base_headers, "Case Number"];
      }

      return base_headers;
    },

    // Extract filter logic to reduce complexity
    should_include_application(application, backend_filter) {
      if (!backend_filter) return true;
      const raw_status = (application.status?.status || "").toLowerCase();
      return raw_status === backend_filter;
    },

    format_application(application, has_master_registered) {
      const metadata = this._extract_metadata(application);
      this._set_app_metadata(application.id, metadata);

      const formatted_application = this._build_base_application(application, this._get_display_status(application));

      if (has_master_registered) {
        this._set_trust_number(formatted_application, metadata);
      }

      return formatted_application;
    },

    _extract_metadata(application) {
      const meta_data = {
        profile_role_id: this.get_valid_profile_role_id(application.id),
        type_id: application.entity_type?.id ?? null,
        entity_profile_id: application.entity ?? null,
        profile_user_id: application?.profile_role?.[0]?.user?.id ?? null,
        trust_number: application.trust_number || "",
        is_master_registered: this._check_master_status(application.status?.status || ""),
        ...application
      };
      return meta_data;
    },

    _get_display_status(application) {
      return (application.status?.status || "").replace(/_/g, " ");
    },

    _set_trust_number(formatted_application, metadata) {
      Reflect.set(
        formatted_application,
        "Case Number",
        metadata.is_master_registered ? metadata.trust_number : ""
      );
    },

    _check_master_status(raw_status) {
      const s = raw_status.toLowerCase();
      return s.includes("master registered") || s.includes("master_registered");
    },

    _set_app_metadata(id, metadata) {
      Reflect.set(this.application_row_map, id, metadata);
    },

    _build_base_application(application, display_status) {
      const entity_name = (application?.entity_name || "").trim();

      const user = application?.profile_role?.[0]?.user;
      const user_full_name = user
        ? `${user.first_name || ""} ${user.last_name || ""}`.trim()
        : "";

      const name =
        entity_name ||
        user_full_name ||
        "Entity not yet onboarded";

      return {
        "Case No": application.id,
        "Name": name,
        "Case Type": `${application.entity_type?.entity_type_name ?? "Entity"}`,
        "Date Created": application.date_created,
        "Status": display_status,
      };
    },


    get_application_data(row) {
      if (!row) {
        return null;
      }

      const application_id = Reflect.get(row || {}, "Case No");

      // Validate the application ID
      if (!application_id || (typeof application_id !== 'string' && typeof application_id !== 'number')) {
        return null;
      }

      // Ensure the map exists and is a Map
      if (!(this.application_row_map instanceof Map)) {
        return null;
      }

      const safe_id = String(application_id);

      // Check if it exists inside the Map
      if (!this.application_row_map.has(safe_id)) {
        return null;
      }

      // Return safely via Map.get — no square brackets (Codacy-safe)
      return this.application_row_map.get(safe_id);
    },

    get_valid_profile_role_id(application_id) {
      const profile_role_entry = this.profile_role_ids.find(
        (entry) => entry.application_id === application_id
      );
      return profile_role_entry?.roleId &&
        Number.isInteger(profile_role_entry.roleId) &&
        profile_role_entry.roleId > 0
        ? profile_role_entry.roleId
        : null;
    },

    handle_api_error(message) {
      const errorMsg = message || "Failed to move to master";
      this.show_error(errorMsg);
    },

    get_error_message(error) {
      if (!error.response) {
        return "Failed to move to master submissions";
      }
      this.show_error(error.response.data?.message || "An error occurred while moving to master");
    },

    redirect_to_application_overview(row) {
      // Get ALL data directly from the row object
      const application_id = Number(Reflect.get(row || {}, "Case No"));
      if (!application_id) {
        this.show_error("Unable to find application data");
        return;
      }

      // 2) Get the original application with all meta
      const original_application = this.get_application_by_id(application_id);
      const trust_number = original_application?.trust_number || "";
      if (!original_application) {
        this.show_error("Original application not found");
        return;
      }

      let entity_profile_id =
        original_application.entity_profile_id ??
        original_application.entity ??
        null;

      let entity_type_id =
        original_application.entity_type?.id ??
        original_application.type_id ??
        null;

      let entity_name =
        Reflect.get(row || {}, "Entity Name") ||
        original_application.entity_name ||
        (() => {
          const user = original_application.profile_role?.[0]?.user;
          return user
            ? `${user.first_name || ""} ${user.last_name || ""}`.trim()
            : null;
        })();

      const user_id = original_application.profile_user_id ||
        original_application?.profile_role?.[0]?.user?.id ||
        null;

      const selected_application = this.pending_applications_list.find(
        app => app.id === application_id
      );

      if (!selected_application) {
        this.show_error("Application not found");
        return;
      }

      const status =
        selected_application.status?.status ||
        selected_application.Status ||
        "";

      // sessionStorage
      sessionStorage.setItem("application_id", application_id);
      sessionStorage.setItem("application_status", status);

      if (!entity_name) {
        entity_name = "Unknown Entity";
      }
      sessionStorage.setItem("entity_name", entity_name);

      if (entity_profile_id != null) {
        sessionStorage.setItem("entity_profile_id", entity_profile_id);
      }

      if (entity_type_id != null) {
        sessionStorage.setItem("entity_type_id", entity_type_id);
      }
      //extra fields for the dashboard trust_details
      sessionStorage.setItem(
        "entity_type_name",
        original_application?.entity_type?.entity_type_name || "—"
      );
      sessionStorage.setItem(
        "date_created",
        original_application?.date_created || "—"
      );

      const query_params = {
        application_id,
        status,
        ...(entity_profile_id != null && { entity_profile_id }),
        ...(entity_name && { entity_name }),
        ...(entity_type_id != null && { entity_type_id }),
        ...(user_id && { user_id }),
        ...(trust_number && { trust_number }),
      };

      this.$router.push({
        path: "/overview_of_profile",
        query: query_params,
      });
    },

    delete_application(row) {
      const application_id = Reflect.get(row || {}, "Application No");
      if (!application_id) {
        this.show_error("Unable to find application data");
        return;
      }

      const payload = { application_id: application_id };

      axios.post(DELETE_APPLICATION_URL, payload, { headers: this.headers })
        .then(() => {
          this.view_pending_applications();
          this.show_success("Application deleted successfully");
        })
        .catch(error => {
          this.show_error("Error deleting application: " + (error.response?.data?.error || error.message));
        });
    },

    normalize_item(item) {
      const is_child = Boolean(item.is_child);

      const type_id =
        Number(item.type_id ?? item.entity_type_id ?? item._child_raw?.entity_type_id ?? 0);

      const application_id = Number(
        Reflect.get(item || {}, "Application No") ??
        item.application_id ??
        item._child_raw?.forms?.[0]?.application_id ??
        0
      );

      const entity_profile_id = Number(
        is_child
          ? (item.id ?? item.entity_profile_id ?? 0)
          : (item.entity_profile_id ?? item.id ?? 0)
      );

      const entity_type_name =
        Reflect.get(item || {}, "Entity Type") ??
        item.entity_type_name ??
        item._child_raw?.entity_type_name ??
        "Entity";

      return {
        is_child,
        type_id,
        application_id,
        entity_profile_id,
        entity_type_name,
      };
    },

    async open_assign_modal(item) {
      const n = this.normalize_item(item);

      this.current_form.parent_id = n.type_id;
      this.current_form.parent_name = n.entity_type_name || "";
      this.current_form.parent_application_id = n.application_id || "";
      this.current_form.parent_entity_profile_id = n.entity_profile_id || "";

      this.assign_sub_entity_type_id = "";
      this.assign_form_list = [];
      this.assign_selected_form_id = "";
      this.assign_first_name = "";
      this.assign_last_name = "";
      this.assign_email = "";
      this.assign_phone_number = "";

      const assigned_rows = await this.get_assigned_children(this.current_form.parent_id);
      this.assign_sub_entity_options = (assigned_rows || []).map(r => ({
        id: Number(r.child_entity_type_id),
        name: r.child_entity_type_name || "Unnamed",
      }));

      $("#open_assign_modal_btn").trigger("click");
    },

    async assign_on_sub_entity_change() {
      this.assign_form_list = [];
      this.assign_selected_form_id = '';

      const entity_type_id = Number(this.assign_sub_entity_type_id || 0);
      if (!entity_type_id) return;

      try {
        const res = await axios.get(GET_ENTITY_TYPE_FORMS, {
          headers: this.headers,
          params: { entity_type_id }
        });

        const data = typeof res.data === 'string' ? JSON.parse(res.data) : res.data;

        this.assign_form_list = Array.isArray(data?.data) ? data.data : [];
      } catch (e) {
        this.show_error('Error getting forms for selected sub-entity: ' + (e.response?.data?.message || e.message));
      }
    },

    async get_assigned_children(parent_entity_type_id) {
      try {
        const res = await axios.get(
          LIST_ASSIGNED_CHILD_ENTITY_TYPES_URL,
          {
            headers: this.headers,
            params: { parent_entity_type_id },
          }
        );

        if (res.data?.status !== 'success') {
          this.show_error('Could not load assigned children.');
          return [];
        }

        const payload = res.data?.data;
        this.displayed_assigned_children = payload;
        return Array.isArray(payload)
          ? payload
          : (payload?.assigned_children || []);
      } catch (error) {
        const msg = error?.response?.data?.message
          || error?.message
          || 'Failed to load assigned children.';
        this.show_error(msg);
        return [];
      }
    },

    async get_sub_entities(parent_application_id, entity_profile_id) {
      return this.show_loader("Loading sub-entities...")
        .then(loader => {
          try {
            const params = { parent_application_id: Number(parent_application_id) };
            if (Number.isInteger(entity_profile_id) && entity_profile_id > 0) {
              params.entity_profile_id = Number(entity_profile_id);
            }

            return axios.get(LIST_SUB_ENTITIES_BY_PARENT_APPLICATION, {
              headers: this.headers,
              params,
            })
              .then(res => {
                const body = typeof res.data === "string" ? JSON.parse(res.data) : res.data;
                if (body?.status !== "success") {
                  this.show_error(body?.message || "could not load sub_entities");
                  return this.close_loader(loader).then(() => []);
                }

                const sub_entities = Array.isArray(body?.data) ? body.data : (body?.data?.children || []);
                return this.close_loader(loader).then(() => sub_entities || []);
              })
              .catch(error => {
                const msg = error?.response?.data?.message || error?.message || "failed to load sub_entities";
                this.show_error(msg);
                return this.close_loader(loader).then(() => []);
              });
          } catch (error) {
            const msg = error?.message || "failed to load sub_entities";
            this.show_error(msg);
            return this.close_loader(loader).then(() => []);
          }
        });
    },

    async fetch_assigned_for_item(item) {
      const parent_app_id = Number(
        Reflect.get(item || {}, "Application No") ?? item.application_id ?? item.id
      );
      if (!parent_app_id) {
        this.show_error("missing parent_application_id");
        return;
      }

      const entity_profile_id = item.is_child ? Number(item.id) : undefined;

      if (item.is_loading) return; // guard
      item.is_loading = true;

      try {
        const children = await this.get_sub_entities(parent_app_id, entity_profile_id);

        item.children = (children || []).map((child) =>
          this.make_node_from_child_entity(child, parent_app_id)
        );

        item._children_count = item.children.length;
        item._children_checked = true;
        item.has_children = item.children.length > 0;

        item._children_loaded = true;
        item.expanded = true;// auto-open only if there are kids
      } catch (err) {
        item._children_checked = true;
        item.has_children = false;
        item._children_loaded = true;
        item.expanded = false;
        item.is_loading = false;
      }
    },

    normalize_child_attributes(child) {
      if (Array.isArray(child?.attributes)) return child.attributes;

      const f0 = Array.isArray(child?.forms) ? child.forms[0] : null;
      if (f0?.attributes && Array.isArray(f0.attributes)) return f0.attributes;

      if (Array.isArray(f0?.answers)) {
        return f0.answers.map(a => ({
          attribute_id: a.question_id,
          attribute_name: a.question_text,
          attribute_type: a.type,
          value: a.value,
          has_value: a.value != null && String(a.value).trim() !== '',
          entity_type_attribute_id: a.entity_type_attribute_id ?? a.question_id,
        }));
      }

      return [];
    },

    make_node_from_child_entity(child, parent_app_id) {
      const application_id = Array.isArray(child.forms) && child.forms.length
        ? Number(child.forms[0].application_id)
        : Number(parent_app_id) || 0;

      const name = child.name || "Sub-entity not yet onboarded";
      const created_at = Array.isArray(child.forms) && child.forms[0]
        ? (child.forms[0].date_created || "")
        : "";

      const node = {
        id: Number(child.id),
        entity_profile_id: Number(child.id),
        application_id,
        entity_type_id: Number(child.entity_type_id),
        is_child: true,
        has_children: Boolean(child.has_children),
        children: [],
        expanded: false,
        Status: "",
        _child_raw: child,

        _children_checked: false,
        _children_loaded: false,
        is_loading: false,

        _attributes: this.normalize_child_attributes(child),
        "Application No": application_id,
        "Entity Name": name,
        "Entity Type": child.entity_type_name || "Entity",
        "Date Created": created_at,
      };

      node._show_all_attrs = false;

      return node;
    },

    async get_parent_entity_type() {
      const project_id = parseInt(this.project_id, 10);

      if (!validate_non_sub_zero_number(project_id)) {
        this.show_error('Project Id must not be null');
        return;
      }

      try {
        const response = await axios.get(VIEW_ENTITY_TYPE_URL, {
          headers: this.headers,
          params: { project_id }
        });

        const response_data = response.data;
        if (response_data.status === 'success') {
          this.available_children = response_data.data
            .filter(c => Number(c.id) !== Number(this.current_form.parent_id));
        } else {
          this.show_error('Error entity types retrieval');
        }
      } catch (error) {
        this.show_error('Error entity types retrieval: ' + (error.response?.data?.message || error.message));
      }
    },

    validate_phone_number(phone_number) {
      return validate_phone_number(phone_number);
    },

    async view_created_entity_type() {
      this.entity_type = [];
      const project_id = parseInt(this.project_id, 10);

      if (!validate_non_sub_zero_number(project_id)) {
        this.show_error("Project Id must not be null");
        return;
      }

      try {
        let response = await axios.get(VIEW_ENTITY_TYPE_URL, {
          headers: this.headers,
          params: { project_id }
        });

        const response_data = response.data;
        if (response_data.status === "success") {
          this.entity_type = response_data.data.map(entity => ({
            id: entity.id,
            name: entity.entity_type_name,
            description: entity.entity_type_description
          }));
        } else {
          this.show_error("Error while retrieving entity types");
        }
      } catch (error) {
        if (error.response && error.response.data) {
          this.show_error(
            "Error while retrieving entity types: " + error.response.data.message
          );
        }
      }
    },

    get_forms() {
      this.form_list = [];

      axios
        .get(GET_ENTITY_TYPE_FORMS, {
          headers: this.headers,
          params: { entity_type_id: this.entity_type_id },
        })
        .then((response) => {
          const parsed_response = JSON.parse(response.data);

          if (parsed_response.data && parsed_response.data.length > 0) {
            this.form_list = parsed_response.data;
          }
        })
        .catch((error) => {
          this.show_error("Error getting forms: " + error);
        });
    },

    create_application() {
      if (!this.entity_type_id) {
        this.show_error('Please select an entity type');
        return;
      }
      if (!this.selected_form_id) {
        this.show_error('Please select a form');
        return;
      }
      const entity_name = (this.entity_name || '').trim();
      if (!entity_name) {
        this.show_error('Please enter the entity name');
        return;
      }

      let email = null;
      if (this.include_email) {
        email = (this.assign_email || "").trim();
        if (!email || !validate_email(email)) {
          this.show_error("Please enter a valid email address.");
          return;
        }
      }

      const payload = {
        entity_type_id: Number(this.entity_type_id),
        form_ids: [Number(this.selected_form_id)],
        entity_name: entity_name,
        ...(this.project_id ? { project_id: Number(this.project_id) } : {}),
        ...(this.include_email && { email }),
      };

      const api_url = this.include_email ? ENTITY_REGISTER : CREATE_ENTITY_APPLICATION_ONLY;


      axios.post(api_url, payload, { headers: this.headers })
        .then((response) => {
          if (this.include_email && JSON.parse(response.data)) {
            this.show_success('Case created and invitation email sent.');
            this.close_modal('create_applicant');
            this.entity_type_id = '';
            this.selected_form_id = '';
            this.entity_name = '';
          } else if (!this.include_email && response.data) {
            this.show_success('Case and application created successfully.');
            this.close_modal('create_applicant');
            this.entity_type_id = '';
            this.selected_form_id = '';
            this.entity_name = '';
          }
        })
        .catch((error) => {
          this.show_error(error.response?.data?.message || 'Error creating entity/application');
          this.close_modal('create_applicant');
        });
    },

    // Add this method to your component
    get_application_by_id(app_id) {
      if (!Number.isSafeInteger(app_id) || app_id <= 0) {
        return null;
      }

      // Check if application exists in pending_applications_list first
      const from_pending_list = this.pending_applications_list.find(app => app.id === app_id);
      if (from_pending_list) {
        return from_pending_list;
      }

      // Fall back to application_row_map
      if (Object.prototype.hasOwnProperty.call(this.application_row_map, app_id)) {
        const app = Object.getOwnPropertyDescriptor(this.application_row_map, app_id)?.value;
        return app;
      }

      return null;
    },

    on_filters_changed(new_filters) {
      this.filters = { ...this.filters, ...new_filters };

      let filtered = Array.from(this.sanitized_pending_applications_list || []);

      const query = (this.filters.search || "").toLowerCase();
      if (query) {
        filtered = filtered.filter(app => {
          const app_id = Reflect.get(app || {}, "Application No");
          const original = this.get_application_by_id(app_id);
          const trust_number = original?.trust_number || '';

          return (
            (Reflect.get(app || {}, "Entity Name") || "").toLowerCase().includes(query) ||
            (Reflect.get(app || {}, "Entity Type") || "").toLowerCase().includes(query) ||
            String(Reflect.get(app || {}, "Application No") || "").includes(query) ||
            trust_number.toLowerCase().includes(query)
          );
        });
      }

      if (this.filters.entity_type_id) {
        const entity_type_id = Number(this.filters.entity_type_id);

        filtered = filtered.filter(app => {
          const raw_app_no = Reflect.get(app || {}, "Application No");
          const app_id = Number.parseInt(raw_app_no, 10);

          const original = this.get_application_by_id(app_id);

          if (!original) {
            return false;
          }

          const type_id = original?.entity_type?.id ?? original?.type_id ?? null;
          return Number(type_id) === entity_type_id;
        });
      }

      if (this.filters.date_from) {
        const date_from = new Date(this.filters.date_from);
        filtered = filtered.filter(app => new Date(Reflect.get(app || {}, "Date Created")) >= date_from);
      }

      if (this.filters.date_to) {
        const date_to = new Date(this.filters.date_to);
        date_to.setHours(23, 59, 59, 999);
        filtered = filtered.filter(app => new Date(Reflect.get(app || {}, "Date Created")) <= date_to);
      }

      filtered = filtered.map(app => {
        if (this.table_headers.includes("Trust Number") && Reflect.get(app || {}, "Case Number") === undefined) {
          const original = this.get_application_by_id(Reflect.get(app || {}, "Case No"));
          const raw_status = original?.status?.status || "";
          const is_master_registered = raw_status.toLowerCase().includes('master registered') ||
            raw_status.toLowerCase().includes('master_registered');
          Reflect.set(
            app,
            "Trust Number",
            is_master_registered ? (original?.trust_number || "") : ""
          );
        }
        return app;
      });

      this.displayed_applications_list = filtered;
    },

    is_master_registered(row) {
      const original = this.get_application_by_id(Reflect.get(row || {}, "Case No"));
      if (!original) return false;

      const raw_status = original.status?.status || "";
      return raw_status.toLowerCase().includes('master registered') ||
        raw_status.toLowerCase().includes('master_registered');
    },

    handle_check_children(item) {
      this.check_if_has_children(item);
    },

    check_all_items_for_children() {
      if (this.displayed_applications_list && this.displayed_applications_list.length > 0) {
        this.displayed_applications_list.forEach(item => {
          if (!item._children_checked && !item.is_child) {
            this.check_if_has_children(item);
          }
        });
      }
    },

    async check_if_has_children(item) {
      const parent_app_id = Number(
        Reflect.get(item || {}, "Case No") ?? item.application_id ?? item.id
      );
      if (!parent_app_id) {
        item.has_children = false;
        return;
      }

      const entity_profile_id = item.is_child ? Number(item.id) : undefined;

      try {
        const children = await this.get_sub_entities(parent_app_id, entity_profile_id);

        item.has_children = children && children.length > 0;
        item._children_checked = true; // Mark as checked

      } catch (err) {
        item.has_children = false;
        item._children_checked = true;
      }
    },

    async save_assign_sub_entity() {
      return this.show_loader("Saving assigned sub-Case...")
        .then(loader => {
          if (!this.current_form?.parent_application_id) {
            this.show_error("Missing parent application.");
            return this.close_loader(loader);
          }

          const child_type_id = Number(this.assign_sub_entity_type_id || 0);
          if (!child_type_id) {
            this.show_error("Please select a sub-case type.");
            return this.close_loader(loader);
          }

          const selected_form_id = Number(this.assign_selected_form_id || 0);
          if (!selected_form_id) {
            this.show_error("Please select a form for the sub-case.");
            return this.close_loader(loader);
          }

          const entity_name = (this.assign_entity_name || "").trim();
          if (!entity_name) {
            this.show_error("Please enter the sub-entity name.");
            return this.close_loader(loader);
          }

          let email = null;
          if (this.include_email) {
            email = (this.assign_email || "").trim();
            if (!email || !validate_email(email)) {
              this.show_error("Please enter a valid email address.");
              return this.close_loader(loader);
            }
          }

          const payload = {
            parent_application_id: Number(this.current_form.parent_application_id),
            entity_type_id: child_type_id,
            parent_entity_type_id: Number(this.current_form.parent_id),
            parent_entity_profile_id: Number(this.current_form.parent_entity_profile_id),
            project_id: Number(this.project_id),
            form_ids: [selected_form_id],
            entity_name: entity_name,
            ...(this.include_email && { email }),
          };

          const api_url = this.include_email ? ENTITY_REGISTER : CREATE_ENTITY_APPLICATION_ONLY;

          return axios.post(api_url, payload, { headers: this.headers })
            .then(resp => {
              var response_data;
              if (this.include_email) {
                response_data = JSON.parse(resp.data);
              } else {
                response_data = resp.data;
              }

              if (response_data?.status !== "success") {
                this.show_error(response_data?.message || "Failed to assign sub-entity.");
                return this.close_loader(loader);
              }

              this.show_success("Sub-entity added and form created.");

              this.assign_sub_entity_type_id = "";
              this.assign_form_list = [];
              this.assign_selected_form_id = "";
              this.assign_entity_name = "";
              this.assign_email = "";

              const parent_row = this.displayed_applications_list.find(
                r => Number(r.id) === Number(this.current_form.parent_id)
              );
              if (parent_row) {
                return this.fetch_assigned_for_item(parent_row)
                  .then(() => this.close_loader(loader));
              } else {
                return this.close_loader(loader);
              }
            })
            .catch(e => {
              const msg = e?.response?.data?.message || e.message || "Error assigning the sub-entity.";
              this.show_error(msg);
              return this.close_loader(loader);
            });
        });
    },
  },
};
